  // booking slider start
  var swiper = new Swiper(".booking-spaces--slider-main", {
        slidesPerView: 1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

  // booking slider end

  // Home event slider end

  var swiper = new Swiper(".home-event", {
    slidesPerView: 1.23,
    spaceBetween: 22,
    breakpoints: {
      650: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
    pagination: {
      el: ".swiper-pagination",
    },
  });

  // Home event slider start

  // booking slider arrow position start
  
  function calcHeights() {
    var totalHeight = $('.booking-spaces--image').innerHeight();
    var infoHeight = totalHeight / 2;
    $('.swiper-button-next, .swiper-button-prev').css('top', infoHeight + 'px');
  };
  $(window).on('resize', function() {
    calcHeights();
  });
  calcHeights();

  // booking slider arrow position End

  
  